webpackJsonp([16],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/blog-post.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _nav = __webpack_require__("./src/components/nav/nav.js");
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _footer = __webpack_require__("./src/components/footer/footer.js");
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '../css/blog-post.css'; // make it pretty!
	
	function Template(_ref) {
	  var data = _ref.data;
	  var post = data.markdownRemark; // data.markdownRemark holds our post data
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        post.frontmatter.title + " | DSA Momentum"
	      )
	    ),
	    _react2.default.createElement(_nav2.default, null),
	    _react2.default.createElement(
	      "div",
	      { className: "main__row" },
	      _react2.default.createElement(
	        "h2",
	        { className: "main__post-title" },
	        post.frontmatter.title
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "main__body-copy main__body-copy--post" },
	        _react2.default.createElement("div", {
	          className: "main__links-section",
	          dangerouslySetInnerHTML: { __html: post.html }
	        })
	      )
	    ),
	    _react2.default.createElement(_footer2.default, null)
	  );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-templates-blog-post-js-df14e50a57b5b927a8e1.js